import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconLink({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M6.5 3.5a2.5 2.5 0 0 0 0 5H7a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 1 1 0-3h5a1.5 1.5 0 0 1 0 3H11a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5h-5zm-4 7a2.5 2.5 0 0 1 0-5H3a.5.5 0 0 1 0 1h-.5a1.5 1.5 0 1 0 0 3h5a1.5 1.5 0 1 0 0-3H7a.5.5 0 0 1 0-1h.5a2.5 2.5 0 0 1 0 5h-5z"/>
        </svg>
    );
}

export default IconLink;
